import { render, staticRenderFns } from "./FreeGetBtns.vue?vue&type=template&id=531dbdec&scoped=true&"
import script from "./FreeGetBtns.vue?vue&type=script&lang=js&"
export * from "./FreeGetBtns.vue?vue&type=script&lang=js&"
import style0 from "./FreeGetBtns.vue?vue&type=style&index=0&id=531dbdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531dbdec",
  null
  
)

export default component.exports